__turbopack_context__.v({
  "archivalLabel": "archival-label-module-scss-module__VUnzcG__archivalLabel",
  "body": "archival-label-module-scss-module__VUnzcG__body",
  "culture": "archival-label-module-scss-module__VUnzcG__culture",
  "gridView": "archival-label-module-scss-module__VUnzcG__gridView",
  "image": "archival-label-module-scss-module__VUnzcG__image",
  "imageWrapper": "archival-label-module-scss-module__VUnzcG__imageWrapper",
  "link": "archival-label-module-scss-module__VUnzcG__link",
  "noImageSvg": "archival-label-module-scss-module__VUnzcG__noImageSvg",
  "title": "archival-label-module-scss-module__VUnzcG__title",
});
